import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/shiftBriefing/useShiftBriefingQueryKeys.ts
var t = e("shift-briefing", { briefing: (e, t) => e ? t ? [
	"briefing",
	e,
	t
] : ["briefing", e] : ["briefing"] });
//#endregion
export { t as shiftBriefingQueryKeys };
